export class APIError extends Error {
    constructor(status, message = "") {
        super(message);
        this.status = status;
    }
}
export const RESTAPIErrorCodes = {
    0: "failed_connection",
    400: "bad_request",
    401: "unauthorized",
    403: "forbidden",
    404: "not_found",
    405: "method_not_allowed",
    409: "conflict",
    500: "internal_server_error",
    501: "not_implemented",
    999: "unknown_error",
};
export function resolveComponent(spec, obj, type) {
    if (obj && "$ref" in obj) {
        const name = obj.$ref.split("/").slice(-1);
        return spec.components?.[type]?.[name];
    }
    else {
        return obj;
    }
}
//# sourceMappingURL=types.js.map